import { render, staticRenderFns } from "./AddPreferenceComponent.vue?vue&type=template&id=319b534e&"
import script from "./AddPreferenceComponent.vue?vue&type=script&lang=js&"
export * from "./AddPreferenceComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports